import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Header from 'Header';
import Dashboard from 'modules/Dashboard';
import BIMModel from 'modules/BIMModel';
import Environment from 'modules/Environment';
import Project from 'modules/Project';
import Monitor from 'modules/Monitor';
import Realname from 'modules/Realname';
import Sensor from 'modules/Sensor';
import Engineering from 'modules/Engineering';
import moment from 'moment';
import './App.styl';
import { CODE } from 'common/js/params';
import 'moment/locale/zh-cn';
import zh from 'antd/es/locale/zh_CN';
import {ConfigProvider} from 'antd';
moment.locale('zh-cn');

class App extends React.Component {
    componentDidMount() {
        this.checkCode();
    }

    checkCode = () => {
        const res = prompt('北京城建智慧工地平台 请输入口令', '');
        if (res !== CODE) {
            alert('北京城建智慧工地平台 口令不正确');
            this.checkCode();
        }
    };

    render() {
        return (
            <div className="smart-site">
                <ConfigProvider
                    locale={zh}
                >
                    <HashRouter>
                        <Header />
                        <section>
                            <Switch>
                                <Route path="/" component={Dashboard} exact />
                                <Route path="/dashboard" component={Dashboard} />
                                <Route path="/bimmodel" component={BIMModel} />
                                <Route path="/environment" component={Environment} />
                                <Route path="/project" component={Project} />
                                <Route path="/monitor" component={Monitor} />
                                <Route path="/realname" component={Realname} />
                                <Route path="/sensor" component={Sensor} />
                                <Route path="/engineering" component={Engineering} />
                            </Switch>
                        </section>
                    </HashRouter>
                </ConfigProvider>
            </div>
        );
    }
}

export default App;
